module.exports = __webpack_public_path__ + "static/media/web-screen.3dcfaa80.svg";